import { Injectable, inject } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, exhaustMap, switchMap, catchError, tap, withLatestFrom } from 'rxjs/operators';
import { SharedService } from '../../services/shared/shared.service';
import * as SharedActions from './shared.actions';
import * as SharedSelector from './shared.selectors';
import { ToastrService } from 'ngx-toastr';
import { select, Store } from '@ngrx/store';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable()
export class SharedEffects {
  private actions$ = inject(Actions);

  //Effects for coutryList.
  countryList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SharedActions.getCountry),
      withLatestFrom(this.store.pipe(select(SharedSelector.getCountryList))),
      exhaustMap((action: any) => {
        if (
          !action[action.length - 1] ||
          (!action[action.length - 1].length && !action[action.length - 1].data?.length)
        ) {
          return this.SharedService.getCountry().pipe(
            map((data: any) => {
              return SharedActions.getCountrySuccess({
                countryList: data.data,
              });
            }),
            catchError((error: any) => of(SharedActions.getCountryFailure(error)))
          );
        } else {
          return of();
        }
      })
    )
  );

  //Effects for planList.

  planList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SharedActions.getPlan),
      switchMap(action => {
        return this.SharedService.getPlan(action.description).pipe(
          map((data: any) => {
            return SharedActions.getPlanSuccess({
              planList: data.data.planItems,
            });
          }),
          catchError((error: any) => of(SharedActions.getPlanFailure(error)))
        );
      })
    )
  );

  //Effects for chekEmailValidation.
  isEmailExistMessage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SharedActions.isEmailExist),
      exhaustMap(action => {
        return this.SharedService.isEmailExist(action.payload).pipe(
          map((data: any) => {
            return SharedActions.isEmailExistSuccess({
              validateEmail: data,
            });
          }),
          catchError((error: any) => of(SharedActions.isEmailExistFailure(error)))
        );
      })
    )
  );

  // hideShowLoader$ = createEffect(
  //   () =>
  //     this.actions$.pipe(
  //       ofType(SharedActions.hideShowLoader),
  //       exhaustMap((action) => {
  //         // if (action.isLoaded) {
  //         //
  //         // } else {
  //         //
  //         // }
  //         return of(SharedActions.hideShowLoader({
  //           isLoaded: true
  //         }));
  //       })
  //     ),
  //   { dispatch: false }
  // );

  ToasterSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SharedActions.ToasterSuccess),
        tap(action => {
          this.toaster.success(action.description);
        })
      ),
    { dispatch: false }
  );

  ToasterWarning$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SharedActions.ToasterWarning),
        tap(action => {
          this.toaster.warning(action.description);
        })
      ),
    { dispatch: false }
  );

  ToasterError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SharedActions.ToasterError),
        tap(action => {
          this.toaster.error(action.description);
        })
      ),
    { dispatch: false }
  );

  getAllGridConfigs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SharedActions.getAllGridConfig),
      exhaustMap(action => {
        return this.SharedService.getAllGridConfigs().pipe(
          map((data: any) => {
            return SharedActions.getAllGridConfigSuccess({
              allGridConfig: data.data,
            });
          }),
          catchError((error: any) => of(SharedActions.getAllGridConfigFailure(error)))
        );
      })
    )
  );

  //Effects for setting grid configuration.
  setGridCofiguration$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SharedActions.setGridCofiguration),
        exhaustMap(action => {
          return of(SharedActions.setGridCofiguration({ gridState: action.gridState }));
        })
      ),
    { dispatch: false }
  );

  //Effects for updating grid configuration.
  updateGridCofiguration$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SharedActions.updateGridCofiguration),
      exhaustMap(action => {
        return this.SharedService.updateColumnConfigs(action.payload).pipe(
          map((data: any) => {
            return SharedActions.updateGridCofigurationSuccess({
              gridState: data.data,
              message: data.message,
            });
          }),
          catchError((error: any) => of(SharedActions.updateGridCofigurationFailure(error)))
        );
      })
    )
  );

  updateGridCofigurationSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SharedActions.updateGridCofigurationSuccess),
      exhaustMap(actions => {
        return of(SharedActions.ToasterSuccess({ description: actions.message }));
      })
    )
  );

  constructor(
    private SharedService: SharedService,
    private toaster: ToastrService,
    private store: Store,
    private spinnerService: NgxSpinnerService
  ) {}
}
